var exports = {
  "N1": "ChannelHeader.module__headerContainer___QmQyQk",
  "dL": "ChannelHeader.module__headerWrapper___QmQyQk",
  "Hv": "ChannelHeader.module__headerWrapperCallActive___QmQyQk",
  "hE": "ChannelHeader.module__headerContainerCallActive___QmQyQk",
  "Ud": "ChannelHeader.module__headerLeftSection___QmQyQk",
  "Gv": "ChannelHeader.module__backButton___QmQyQk",
  "wK": "ChannelHeader.module__backButtonDesktop___QmQyQk" + " " + "ChannelHeader.module__backButton___QmQyQk",
  "j2": "ChannelHeader.module__backIcon___QmQyQk",
  "Ir": "ChannelHeader.module__backIconBold___QmQyQk" + " " + "ChannelHeader.module__backIcon___QmQyQk",
  "CY": "ChannelHeader.module__leftContentContainer___QmQyQk",
  "Bn": "ChannelHeader.module__voiceCallHeaderSupplement___QmQyQk",
  "BN": "ChannelHeader.module__mobileButton___QmQyQk",
  "Vt": "ChannelHeader.module__desktopButton___QmQyQk" + " " + "ChannelHeader.module__mobileButton___QmQyQk",
  "R3": "ChannelHeader.module__avatarWrapper___QmQyQk",
  "ax": "ChannelHeader.module__groupDmHeaderTrigger___QmQyQk",
  "_D": "ChannelHeader.module__groupDmHeaderInner___QmQyQk",
  "ab": "ChannelHeader.module__groupDmEditIcon___QmQyQk",
  "HA": "ChannelHeader.module__channelName___QmQyQk",
  "$7": "ChannelHeader.module__groupDmChannelName___QmQyQk",
  "kf": "ChannelHeader.module__dmNameWrapper___QmQyQk",
  "a1": "ChannelHeader.module__userTag___QmQyQk",
  "p": "ChannelHeader.module__channelIcon___QmQyQk",
  "ml": "ChannelHeader.module__caretRight___QmQyQk",
  "Nj": "ChannelHeader.module__channelInfoContainer___QmQyQk",
  "u8": "ChannelHeader.module__followButton___QmQyQk",
  "B6": "ChannelHeader.module__topicDivider___QmQyQk",
  "zm": "ChannelHeader.module__topicContainer___QmQyQk",
  "yu": "ChannelHeader.module__topicButton___QmQyQk",
  "Am": "ChannelHeader.module__topicButtonOverflow___QmQyQk",
  "lY": "ChannelHeader.module__headerRightSection___QmQyQk",
  "P0": "ChannelHeader.module__messageSearchFocusWrapper___QmQyQk",
  "bS": "ChannelHeader.module__headerContainerThreadPanelOpen___QmQyQk",
  "gb": "ChannelHeader.module__iconButton___QmQyQk",
  "f5": "ChannelHeader.module__iconButtonDefault___QmQyQk" + " " + "ChannelHeader.module__iconButton___QmQyQk",
  "vR": "ChannelHeader.module__iconButtonSelected___QmQyQk" + " " + "ChannelHeader.module__iconButton___QmQyQk",
  "rB": "ChannelHeader.module__updateIconButton___QmQyQk" + " " + "ChannelHeader.module__iconButton___QmQyQk",
  "l_": "ChannelHeader.module__updateIcon___QmQyQk",
  "Do": "ChannelHeader.module__updateIconSpinning___QmQyQk" + " " + "ChannelHeader.module__updateIcon___QmQyQk",
  "bx": "ChannelHeader.module__updateIconSpin___QmQyQk",
  "IC": "ChannelHeader.module__iconButtonMobile___QmQyQk",
  "iA": "ChannelHeader.module__buttonIcon___QmQyQk",
  "qt": "ChannelHeader.module__buttonIconMobile___QmQyQk",
  "Dm": "ChannelHeader.module__iconButtonWrapper___QmQyQk",
  "W9": "ChannelHeader.module__unreadPinIndicator___QmQyQk",
};

module.exports = exports;
